<template>
  <div class="social-step-editor-sidebar-text">
    <div v-for="piece in pieces" :key="piece.id">
      <div v-if="limits[piece.name] && !isDisabled(piece.name)" class="social-step-editor-sidebar-text__group">
        <shared-step-editor-textarea-field
            :input-value="piece.content"
            :maxlength="limits[piece.name]"
            :height="40"
            :error="failed && piece.content.length < 1 ? `Shouldn't be empty` : ''"
            :label="normalizedName(piece.name)"
            error-position="absolute"
            responsive
            class="social-step-editor-sidebar-text__textarea"
            @input="onInput(piece.id, $event)"
        />
        <div class="d-flex flex-row-reverse justify-content-between">
          <shared-step-editor-input-counter :input="piece.content" :max="limits[piece.name]"/>
          <shared-step-editor-smart-text :piece="piece" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SharedStepEditorTextareaField from '../../shared/form/SharedStepEditorTextareaField';
import SharedStepEditorInputCounter from '../../shared/form/SharedStepEditorInputCounter';
import SharedStepEditorSmartText from '../../shared/form/SharedStepEditorSmartText.vue';
import {SocialPostTypes} from '../SocialPostTypes';
import {SocialPostPieceNames} from '../SocialPostPieceNames';

export default {
  components: {SharedStepEditorTextareaField, SharedStepEditorInputCounter, SharedStepEditorSmartText},
  data() {
    return {
      textLoading: false,
    }
  },
  props: {
    pieces: Array,
    activityType: String,
    advancedMode: Boolean,
    failed: Boolean,
  },
  methods: {
    onInput(id, content) {
      this.$emit('update', {id, content});
    },
    normalizedName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    isDisabled(name) {
      return this.advancedMode && !this.enabledPiecesInAdvance.includes(name);
    },
  },
  computed: {
    enabledPiecesInAdvance() {
      return [SocialPostPieceNames.PersonalMessage, SocialPostPieceNames.Message];
    },
    messageLimit() {
      switch (this.activityType) {
        case SocialPostTypes.FacebookPagePosts:
        case SocialPostTypes.FacebookPersonalPosts:
          return 63206;
        case SocialPostTypes.LinkedInPersonalPosts:
          return 1300;
        case SocialPostTypes.TwitterPersonalPosts:
          return 280;
        default:
          return undefined;
      }
    },
    limits() {
      return {
        [SocialPostPieceNames.Title]: 80,
        [SocialPostPieceNames.CallToAction]: 80,
        [SocialPostPieceNames.Description]: 200,
        [SocialPostPieceNames.Caption]: 200,
        [SocialPostPieceNames.Message]: this.messageLimit,
        [SocialPostPieceNames.PersonalMessage]: this.messageLimit,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.social-step-editor-sidebar-text {
  padding: 24px 16px;

  &__textarea {
    width: 100%;
    word-break: break-word;
    border: none;
  }

  &__group {
    margin-bottom: 16px;
  }
}
</style>
